module.exports = __webpack_public_path__ + "media/apps/app-download-m-phone-4ebf6b92.webp";